import { FC, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import PhoneNumberInput from 'components/PhoneNumberInput'
import VerificationInputField from 'components/VerificationInputField'
import { useAuth } from 'customHooks/useAuth'
import { CompleteContentContainer } from './style';
import StyledButton from 'components/Button';
import { useMutation } from '@apollo/client';
import { SEND_PHONE_NUMBER_VERIFICATION_CODE, VERIFY_PHONE_NUMBER } from 'graphql/service';
import setPhoneNumberImage from 'assets/icons/setPhoneNumber.jpg';
import { useGlobalAlerts } from 'customHooks/useGlobalAlerts';
// import {
//   mockSendVerificationCode,
//   mockVerifyPhoneNumber
// } from 'mocks/phoneVerificationMock';
import { useSetRecoilState } from 'recoil';
import { userInfoState} from 'states/CheckOutStates/atoms'
const CompleteContent: FC = () => {


  const setUserInfo = useSetRecoilState(userInfoState);
  
  const debug = false;

  const history = useHistory()
  const { validToken, userId, refreshUserInfo } = useAuth()

  const [phoneNumber, setPhoneNumber] = useState('')
  const [phoneNumberValidity, setPhoneNumberValidity] = useState(false)
  const [phoneNumberError, setPhoneNumberError] = useState(false)
  const [phoneNumberSubmitted, setPhoneNumberSubmitted] = useState(false)
  
  const { showGlobalError, showGlobalMessage } = useGlobalAlerts();

  const CODE_LENGTH = 6;
  const [verificationCode, setVerificationCode] = useState<string[]>(Array(CODE_LENGTH).fill(''));

  useEffect(() => {
    if(phoneNumberValidity) {
      setPhoneNumberError(false)
    }
  }, [phoneNumberValidity, setPhoneNumberError])

  const [sendPhoneNumberVerificationCode] = useMutation(
    SEND_PHONE_NUMBER_VERIFICATION_CODE,
    {
      onCompleted: (sendPhoneNumberVerificationCodeData)=> {
        if(sendPhoneNumberVerificationCodeData.sendPhoneNumberVerificationSMS) {
          setPhoneNumberSubmitted(true)
          showGlobalMessage ("Verification code is sent to your phone.");
        } else {
          const content = 'Send phone number verification code failed!'
          console.log(content)
          showGlobalError (content);
        }
      },
      onError: (error)=> {
        const content = error.message
        console.log(content)
        showGlobalError (content);
      }
    }
  )

  const [verifyPhoneNumber] = useMutation(
    VERIFY_PHONE_NUMBER,
    {
      onCompleted: (verifyPhoneNumberData)=> {
        if(verifyPhoneNumberData.verifyPhoneNumber) {
          setUserInfo((userInfo)=>({
            ...userInfo,
            phoneNumberInput: phoneNumber
          }))
          
          if (debug) {
            console.log ('phoneNumber - ', phoneNumber);
          }
          refreshUserInfo();

          history.push('/account/dashboard')
          showGlobalMessage ("Your phone number has been successfully linked to your account.");
        } else {
          const content = 'Verification failed!'
          console.log(content)
          showGlobalError (content);
        }
      },
      onError: (error)=> {
        const content = error.message
        console.log(content)
        showGlobalError (content);
      }
    }
  )
  
  
  // Old code - https://rookhotel.atlassian.net/browse/RHCFW-413
  // const handleSubmit = () => {
  //   if(validToken) {
  //     sendPhoneNumberVerificationCode({
  //       variables: {
  //         input: {
  //           phoneNumber,
  //           userId,
  //         }
  //       }
  //     })
  //   } else {
  //     console.log('Session expired, please try again!')
  //     showGlobalError ('Session expired, please try again!');
  //     history.push('/sign-in')
  //   }
  // }

  // Code with mocks
  // const handleSubmit = async () => {
  //   if (!validToken) {
  //     showGlobalError("Session expired, please try again!");
  //     history.push("/sign-in");
  //     return;
  //   }
  
  //   if (!phoneNumberValidity) {
  //     setPhoneNumberError(true);
  //     return;
  //   }
  
  //   try {
  //     const res = await mockSendVerificationCode();
  
  //     if (res.sendPhoneNumberVerificationSMS) {
  //       setPhoneNumberSubmitted(true);
  //       showGlobalMessage("Verification code is sent to your phone.");
  //     }
  //   } catch {
  //     showGlobalError("Something went wrong, try again later.");
  //   }
  // };

  // Code with real endpoint
  const handleSubmit = () => {
    if (!validToken) {
      showGlobalError('Session expired, please try again!');
      history.push('/sign-in');
      return;
    }
  
    if (!phoneNumberValidity) {
      setPhoneNumberError(true);
      return;
    }
  
    sendPhoneNumberVerificationCode({
      variables: {
        input: {
          phoneNumber,
          userId,
        }
      }
    });
  };

  // Old code - https://rookhotel.atlassian.net/browse/RHCFW-413
  // const handleVerifyPhoneNumber = () => {
  //   if(validToken) {
  //     verifyPhoneNumber({
  //       variables: {
  //         input: {
  //           phoneNumber,
  //           token: verificationCode.join(''),
  //         }
  //       }
  //     })
  //   } else {
  //     console.log('Session expired, please try again!')
  //     showGlobalError ('Session expired, please try again!');
  //     history.push('/sign-in')
  //   }
  // }


    // Code with mocks
  // const handleVerifyPhoneNumber = async () => {
  //   if (!validToken) {
  //     showGlobalError("Session expired, please try again!");
  //     history.push("/sign-in");
  //     return;
  //   }
  
    
  //   const isFullCode = verificationCode.every(d => d.trim() !== "");
  
  //   if (!isFullCode) {
  //     showGlobalError("Please enter the full verification code.");
  //     return;
  //   }
  
  //   const code = verificationCode.join("");
  //   console.log("code:", code);
  
  //   try {
  //     const res = await mockVerifyPhoneNumber();
  
  //     if (res.verifyPhoneNumber) {
  //       showGlobalMessage("Your phone number has been successfully linked to your account.");
  //       history.push("/account/dashboard");
  //     }
  
  //   } catch {
  //     showGlobalError("Could not verify the code, try again.");
  //   }
  // };

  // Code with real endpoint
  
  const isFullCode = verificationCode.every(d => d.trim() !== '');
  const handleVerifyPhoneNumber = () => {
    if (!validToken) {
      showGlobalError('Session expired, please try again!');
      history.push('/sign-in');
      return;
    }
  
    //const isFullCode = verificationCode.every(d => d.trim() !== "");
    if (!isFullCode) {
      showGlobalError("Please enter the full verification code.");
      return;
    }
  
    verifyPhoneNumber({
      variables: {
        input: {
          phoneNumber,
          token: verificationCode.join(''),
        }
      }
    });
  };
  
  

  return (
    <CompleteContentContainer>
      <div className="titleContainer">
        <div className="innerContainer">
          <div className='titleText'>
            <div className="title">
              <div className="titleFirstLine">Unlock your stay! <span className='highLight'>Verify your number</span> for seamless access and security.</div>
            </div>
          </div>
          <img src={setPhoneNumberImage} alt="Set phone number" className="setPhoneNumberImage" />
          
        </div>
      </div>
      <div className="inputRow">
        {!phoneNumberSubmitted? (
          <div className="inputContainerSetPhoneNumber">
            <div className="description">
              Please enter <span className='highLight'>your phone number</span> to link it to your account. This will help us verify your identity, make check-ins a breeze at our kiosks, and assist you in recovering your account if you forget your password. After entering your number, you’ll receive <span className='highLight'>a 6-digit code</span> to confirm it’s valid.
            </div>
            <div className="phoneNumberContainer">
            <PhoneNumberInput
              className='phoneNumberInput'
              label="PHONE NUMBER"
              labelSize={'14px'}
              labelWeight={'400'}
              isRequired={true}
              inputFontSize={'16px'}
              inputFontWeight={'400'}
              labelPosition='left'
              error={!phoneNumberValidity && phoneNumberError}
              errorMessage='Please enter a valid phone number'
              inputHeight="47px"
              // width='60%'
              marginBottom={'20px'}
              onChangeNumber={setPhoneNumber}
              setPhoneNumberValidity={setPhoneNumberValidity}
              onBlur={() => {
                if(!phoneNumberValidity&&phoneNumber.length<3) {
                  setPhoneNumberError(true)
                }
              }}
            />
            <div className="submitButtonContainer">
            <StyledButton
              width="114px"
              height="48px"
              disabled={phoneNumberError}
              margin={'10px 0 0 0'}
              onClick={handleSubmit}
            >
              Submit
            </StyledButton>
            </div>
            </div>
          </div>
      ): (
        <div className="verifyContainer">
          <div className='verifyTitle'>
            <div>Verify phone number</div>
          </div>
          <div className="description">
            <div>A verification code has been sent to your current phone number ending in {phoneNumber.substring(phoneNumber.length - 4)}. Please enter the code below to confirm your update:</div>
          </div>
          <div className="verificationInputBox">
          <VerificationInputField
            label="Verification Code"
            isRequired
            margin='20px 0'
            width='100%'
            length={CODE_LENGTH}
            values={verificationCode}
            setValues={setVerificationCode}
          />
          </div>
          <div className="verifyButtonContainer">
          <StyledButton
            width="196px"
            height="48px"
            disabled={!isFullCode}
            margin={'10px 0'}
            onClick={handleVerifyPhoneNumber}
          >
            Verify Phone Number
          </StyledButton>
          </div>
          <div className="description dontR">
            <div>Didn’t receive the code?&nbsp;
              <span
                className='highLight'
                onClick={handleSubmit}
              >
                 Resend it
              </span>
              .
            </div>
          </div>
        </div>
      )}
      </div>
    </CompleteContentContainer>
  )
}

export default CompleteContent;